<template>
  <div class="translate_wrapper">
    <div class="translate_wrapper" :class="{ active: isActive }">
      <div class="current_lang">
        <div class="lang">
          <i class="fa fa-user" @click="toggleActive"></i>
          <span class="lang-txt">{{ langLanguage }}</span>
        </div>
      </div>

      <div class="more_lang" :class="{ active: isActive }">
        <div class="lang" v-for="(lang, index) in localOptions" :key="index">
          <i class="fa fa-user-plus"></i>
          <span class="lang-txt" @click.prevent="changeLocale(lang)">
            {{ lang.name }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import axios from "@/includes/connection";

const localOptions = ref([]);

const listUserRoles = async () => {
  //console.log("user choose: ", localStorage.getItem("userId"));
  await axios
    .get("/rol/user-roles/" + localStorage.getItem("userId"))
    .then((response) => {
      localOptions.value = response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};

const isActive = ref(false);
const currentLanguage = ref(localStorage.getItem("currentRol") || "Usuario");

const langLanguage = computed(() => currentLanguage.value);

function toggleActive() {
  isActive.value = !isActive.value;
}

function changeLocale(language) {
  currentLanguage.value = language.name;
  localStorage.setItem("currentRol", language.name);
  localStorage.setItem("currentRolId", language.id);
  //console.log("currentRol: ", currentLanguage.value);
  location.reload(); // Reload the page after changing the role
}

onMounted(() => {
  // changeLocale(currentLanguage.value);
  listUserRoles();
});
</script>
